<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="總銷售額"
          :value="stats.money.value"
          :percentage="{
            value: stats.money.percentage,
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-money-coins',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="總訂單數"
          :value="stats.users.value"
          :percentage="{
            value: stats.users.percentage,
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-cart',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="總商品數"
          :value="stats.clients.value"
          :percentage="{
            value: stats.clients.percentage,
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-box-2',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <mini-statistics-card
          title="LINE 訊息額度"
          :value="stats.lineQuota.value"
          :percentage="{
            value: stats.lineQuota.percentage,
            color: stats.lineQuota.color || 'text-success',
          }"
          :icon="{
            component: 'ni ni-chat-round',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7 mb-lg-0 mb-4">
        <!-- Brand Card removed from top row to fit LINE card, moved or just replaced? -->
        <!-- Option: Make the top row 5 cols or 4 cols and push brands down? 
             Wait, original has 4 cols: Sales, Orders, Products, Brands.
             I will replace Brands with LINE for now as it's more critical given the request,
             OR better, I will check if I can add a 5th col or just add it to a new row.
             The user asked to ADD it. Let's look at the structure.
             It's a row with col-xl-3 (4 items). If I add one, it will wrap.
             Let's put Brands and LINE in the same row if it wraps, or replace Brands if space is tight?
             Let's re-arrange. I will replace the last one (Brands) with LINE Quota for visibility as requested, 
             OR just append it. "d-flex" isn't used on row, it's a bootstrap row.
             Appending it will make it drop to next line on xl.
             Let's Modify the row to include 5 items or just append. 
             Actually, let's keep Brands and verify I can add it nicely.
             The user said "多一個目前line額度".
             I'll modify the loop or structure.
             Original code:
             1. Sales
             2. Orders
             3. Products
             4. Brands
             
             I will change it to:
             1. Sales
             2. Orders
             3. LINE Quota (Priority)
             4. Products
             (And maybe drop Brands or move it).
             
             Let's just replace the Brands block in this specific tool call with LINE Quota block for now, 
             as requested "多一個" implies addition but I need to fit it. 
             Actually, I can just add it as a 5th card? No, col-xl-3 * 4 = 12.
             I'll replace 'Brands' slot with 'LINE Quota' based on context 'User wants to know quota'. 
             Brands stats are less critical for 'messaging'. 
             
             Wait, I shouldn't delete Brands without asking.
             I will assume I should add it. I'll search for where 'Brands' is.
             It is at the 4th position.
             
             Let's just *change* the 4th column to be LINE Quota.
             User said "多一個", so "Add one".
             
             Actually, I will keep Brands and add LINE Quota. 
             If I duplicate the col div, it will just wrap to next line. That's fine.
        -->
        <mini-statistics-card
          title="總品牌數"
          :value="stats.sales.value"
          :percentage="{
            value: stats.sales.percentage,
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-tag',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0">
        <mini-statistics-card
          title="LINE 訊息額度"
          :value="stats.lineQuota.value"
          :percentage="{
            value: stats.lineQuota.percentage,
            color: stats.lineQuota.color || 'text-success',
          }"
          :icon="{
            component: 'ni ni-chat-round',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7 mb-lg-0 mb-4">
        <div class="card">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-lg-6">
                <div class="d-flex flex-column h-100">
                  <p class="mb-1 pt-2 text-bold">GolfLinker 管理後台</p>
                  <h5 class="font-weight-bolder">歡迎回來，管理員</h5>
                  <p class="mb-5">
                    這裡您可以管理所有的商品、訂單、品牌以及會員資訊。
                  </p>
                  <a
                    class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                    href="javascript:;"
                  >
                    閱讀更多
                    <i
                      class="fas fa-arrow-right text-sm ms-1"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
              <div class="col-lg-5 ms-auto text-center mt-5 mt-lg-0">
                <div class="bg-gradient-success border-radius-lg h-100">
                  <img
                    src="../assets/img/shapes/waves-white.svg"
                    class="position-absolute h-100 w-50 top-0 d-lg-block d-none"
                    alt="waves"
                  />
                  <div
                    class="position-relative d-flex align-items-center justify-content-center h-100"
                  >
                    <img
                      class="w-100 position-relative z-index-2 pt-4"
                      src="../assets/img/illustrations/rocket-white.png"
                      alt="rocket"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="card h-100 p-3">
          <div
            class="overflow-hidden position-relative border-radius-lg bg-cover h-100"
            style="
              background-image: url('https://demos.creative-tim.com/soft-ui-dashboard/assets/img/ivancik.jpg');
            "
          >
            <span class="mask bg-gradient-dark"></span>
            <div class="card-body position-relative z-index-1 p-3 h-100">
              <div class="d-flex flex-column h-100">
                <h5 class="text-white font-weight-bolder mb-4 pt-2">
                  打造最佳高爾夫交易平台
                </h5>
                <p class="text-white mb-5">
                  我們致力於提供最透明、安全、便利的二手高爾夫球具交易體驗。
                </p>
                <a
                  class="text-white font-weight-bold ps-1 mb-0 icon-move-left mt-auto"
                  href="javascript:;"
                >
                  閱讀更多
                  <i
                    class="fas fa-arrow-right text-sm ms-1"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 row">
      <div class="mb-4 col-lg-5 mb-lg-0">
        <div class="card z-index-2">
          <div class="p-3 card-body">
            <reports-bar-chart
              id="chart-bar"
              title="營運概況"
              :description="`(<strong>${
                stats.metrics.weekly_growth > 0 ? '+' : ''
              }${stats.metrics.weekly_growth}%</strong>) 比上週`"
              :chart="stats.salesChart"
              :items="[
                {
                  icon: {
                    color: 'primary',
                    component: faUsers,
                  },
                  label: '新註冊用戶',
                  progress: {
                    content: stats.metrics.new_users.toString(),
                    percentage: 60,
                  },
                },
                {
                  icon: { color: 'info', component: faHandPointer },
                  label: '新訂單',
                  progress: {
                    content: stats.metrics.new_orders.toString(),
                    percentage: 90,
                  },
                },
                {
                  icon: { color: 'warning', component: faCreditCard },
                  label: '這周營銷',
                  progress: {
                    content:
                      'NT$ ' +
                      parseInt(stats.metrics.weekly_sales).toLocaleString(),
                    percentage: 30,
                  },
                },
                {
                  icon: { color: 'danger', component: faScrewdriverWrench },
                  label: `本月營銷 (${
                    stats.metrics.monthly_growth > 0 ? '+' : ''
                  }${stats.metrics.monthly_growth}%)`,
                  progress: {
                    content:
                      'NT$ ' +
                      parseInt(stats.metrics.monthly_sales).toLocaleString(),
                    percentage: 50,
                  },
                },
              ]"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <!-- line chart -->
        <div class="card z-index-2">
          <gradient-line-chart
            id="chart-line"
            title="趨勢圖"
            description="<i class='fa fa-arrow-up text-success'></i> <span class='font-weight-bold'>4% 增長</span> 今年"
            :chart="stats.usersChart"
          />
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-lg-8 col-md-6 mb-md-0 mb-4">
        <projects-card title="Recent Orders" :orders="stats.recentOrders" />
      </div>
      <div class="col-lg-4 col-md-6">
        <blog-post-card :post="stats.latestPost" />
      </div>
    </div>
  </div>
</template>
<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import ProjectsCard from "./components/ProjectsCard.vue";
import BlogPostCard from "./components/BlogPostCard.vue";
import request from "@/utils/request";
import {
  faHandPointer,
  faUsers,
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "dashboard-default",
  data() {
    return {
      iconBackground: "bg-gradient-success",
      faCreditCard,
      faScrewdriverWrench,
      faUsers,
      faHandPointer,
      showUnreadAlert: false, // Control alert visibility
      unreadCount: 0,
      stats: {
        money: { value: "$0", percentage: "+0%" },
        users: { value: "0", percentage: "+0%" },
        clients: { value: "0", percentage: "+0%" },
        sales: { value: "$0", percentage: "+0%" },
        lineQuota: {
          value: "檢查中...",
          percentage: "載入中",
          color: "text-secondary",
        },
        salesChart: {
          labels: [],
          datasets: { label: "Sales", data: [] },
        },
        usersChart: {
          labels: [],
          datasets: [],
        },
        recentOrders: [],
        metrics: {
          new_users: 0,
          new_orders: 0,
          weekly_sales: 0,
          monthly_sales: 0,
          weekly_growth: 0,
          monthly_growth: 0,
        },
        latestPost: null,
      },
    };
  },
  components: {
    MiniStatisticsCard,
    ReportsBarChart,
    GradientLineChart,
    ProjectsCard,
    BlogPostCard,
  },
  async created() {
    try {
      const response = await request.get("/api/admin/dashboard");
      const data = response.data;

      // Update Summary Cards
      this.stats.money = {
        value: `NT$ ${parseInt(data.summary.sales).toLocaleString()}`,
        percentage: "+100%",
      };
      this.stats.users = {
        value: `${data.summary.orders}`,
        percentage: "Orders",
      };
      this.stats.clients = {
        value: `${data.summary.products}`,
        percentage: "Products",
      };
      this.stats.sales = {
        value: `${data.summary.brands}`,
        percentage: "Brands",
      };

      // LINE Quota
      if (data.line_quota) {
        const usage = data.line_quota.usage;
        const limit = data.line_quota.limit;
        const type = data.line_quota.type;

        if (type === "none") {
          this.stats.lineQuota = {
            value: "無限制",
            percentage: `已使用: ${usage}`,
            color: "text-success",
          };
        } else {
          const remaining = limit - usage;
          const percentageUsed = limit > 0 ? (usage / limit) * 100 : 0;
          let color = "text-success";
          if (percentageUsed > 80) color = "text-warning";
          if (percentageUsed > 95) color = "text-danger";

          this.stats.lineQuota = {
            value: `${remaining}`,
            percentage: `已使用: ${usage} / ${limit}`,
            color: color,
          };
        }
      } else {
        this.stats.lineQuota = {
          value: "未設置",
          percentage: "請至設定頁",
          color: "text-secondary",
        };
      }

      // Update Charts
      this.stats.salesChart = {
        labels: data.charts.sales.labels,
        datasets: {
          label: "銷售額",
          data: data.charts.sales.data,
        },
      };

      this.stats.usersChart = {
        labels: data.charts.users.labels,
        datasets: [
          {
            label: "新用戶",
            data: data.charts.users.data,
          },
        ],
      };

      // Unread Messages Alert
      if (data.summary.unread_message_orders_count > 0) {
        this.unreadCount = data.summary.unread_message_orders_count;
        this.showUnreadAlert = true;
        // Use Ant Design Notification if available, or just a custom alert
        this.$notify({
          title: "新訊息通知",
          text: `您有 ${this.unreadCount} 筆訂單有未讀訊息，請盡快查看。`,
          type: "warning",
          duration: 10000,
        });
      }

      this.stats.recentOrders = data.recent_orders;
      this.stats.metrics = data.metrics;
      this.stats.latestPost = data.latest_post;
    } catch (error) {
      console.error("Failed to fetch dashboard data", error);
    }
  },
};
</script>
